<!--
 * @Author: your name
 * @Date: 2021-11-23 09:44:50
 * @LastEditTime: 2021-12-06 14:40:34
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\components\payment-detail-table\index.vue
-->
<template>
  <a-card size="small" class="payment-detail-table">
    <a-table
      row-key="id"
      size="small"
      :bordered="true"
      :data-source="data?.receiptWriteenOffDetailQueryAResps"
      :columns="columns"
      :scroll="{ x: true }"
      :pagination="false"
    >
      <template #index="{ index }">{{ index + 1 }}</template>
      <template #footer>
        <div class="ant-table-bordered">
          <div class="ant-table-tbody">
            <tr>
              <td style="width: 60px"></td>
              <td style="width: 150px">总计</td>
              <td style="width: 150px"></td>
              <td style="width: 200px">
                {{ $filters.formatMoney(currentCollectionTotalPrice) }}
              </td>
              <td style="width: 250px">
                <!-- {{ $filters.formatMoney(currentWrittenOffTotalPrice) }} -->
              </td>
              <td style="width: 150px"></td>
            </tr>
          </div>
        </div>
      </template>
    </a-table>
  </a-card>
</template>

<script lang="ts">
import { message } from "ant-design-vue";
import { computed, defineComponent, reactive, toRefs, onMounted } from "vue";
import { columns } from "./constant";
import { countTotalPrice } from "@/utils";
import { makeInvoiceService } from "@/views/ticket/makeTicket/makeTicket.service";
export default defineComponent({
  name: "PaymentDetailTable",
  props: {
    invoiceId: {
      type: String,
      required: true,
    },
  },
  emits: ["update:value"],
  setup(props) {
    const state = reactive({
      receiptWriteenOffDetailQueryAResps: [],
      // currentWrittenOffTotalPrice: computed(() =>
      //   countTotalPrice(state.data.receiptWriteenOffDetailQueryAResps, "currentWrittenOff")
      // ),
      currentCollectionTotalPrice: computed(() =>
        countTotalPrice(state.data.receiptWriteenOffDetailQueryAResps, "currentCollectionAmount")
      ),
      data: {},
    });
    const { loading: detailLoading, run: runDetail } = makeInvoiceService.paymentPage();
    onMounted(async () => {
      let detail = await runDetail({ invoiceId: props.invoiceId });
      if (detail.respCode !== "0000") {
        message.error(detail.respDesc);
        return;
      }
      if (detail.data) {
        const { data } = detail;
        state.data = data;
      }
    });
    return {
      ...toRefs(state),
      columns,
      detailLoading,
    };
  },
});
</script>
<style lang="less" scoped>
.payment-detail-table {
  :deep(.ant-table.ant-table-bordered .ant-table-footer) {
    padding: 0;
  }
}
</style>

